// Initial candidate training form state
export const initialCandidateTraining = {
  trainingId: '',
  class_id: '',
  status: 'ENROLLED',
  rating: 0,
  feedback: '',
};

// Status options matching Sales Training
export const statusOptions = [
  { value: 'ENROLLED', text: 'Enrolled' },
  { value: 'IN_PROGRESS', text: 'In Progress' },
  { value: 'COMPLETED', text: 'Completed' },
  { value: 'DROPPED', text: 'Dropped' },
];

// Filter categories for the filter popup
export const filterCategories = [
  'Class Name',
  'Status',
  'Faculty Name',
];

// Prepare training data for editing from API response
export const prepareTrainingForEdit = (training) => {
  if (!training) return null;

  return {
    trainingId: training.training_id || training.record_id || training.id,
    class_id: training.class_id || '',
    status: training.status || 'ENROLLED',
    rating: training.rating || 0,
    feedback: training.feedback || '',
    // Audit fields
    created: training.created || '',
    created_by: training.created_by || '',
    updated: training.updated || '',
    updated_by: training.updated_by || '',
  };
};

// Prepare form data for API submission
export const prepareTrainingPayload = (formData, candidateId) => {
  const payload = {
    candidateId: +candidateId,
    status: formData.status,
  };

  // Add class_id if provided
  if (formData.class_id) {
    payload.classId = +formData.class_id;
  }

  // Add rating if provided and > 0
  if (formData.rating && formData.rating > 0) {
    payload.rating = +formData.rating;
  }

  // Add feedback if provided
  if (formData.feedback?.trim()) {
    payload.feedback = formData.feedback.trim();
  }

  return payload;
};
